function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import { Button, Box, Card, Divider, Drawer, Flex, Heading, Link, Markdown, Notice, Stepper, StickyBar, Tag, Text, Tooltip, useId } from '@applyboard/crystal-ui';
import { AwardOutlineIcon, CloseOutlineIcon, DashboardOutlineIcon, InfoOutlineIcon, LocationOutlineIcon, MenuLeftCollapseOutlineIcon, MenuLeftExpandOutlineIcon, WarningOutlineIcon } from '@applyboard/ui-icons';
import { useApplicationWorkflows } from "../../data/applicationWorkflows";
import { useApplicationMainIntake } from "../../data/intakes";
import { assert } from "../../../../utils/assert";
import { format } from 'date-fns';
import { ErrorBoundary } from 'react-error-boundary';
import { IllustratedErrorState } from "../../../../components/IllustratedErrorState";
import { useEventTracker, useTranslation } from '@applyboard/ui-utils';
import { formatDurationRange } from "../../../../utils/duration";
import { match } from 'ts-pattern';
import { ManageBackupProgramsButton } from "../ManageBackupProgramsButton";
import { RecommendedProgramsButton } from "../RecommendedProgramsButton";
import { formatDetailedDeadline } from "../../../../utils/dates";
import { useRef, useState } from 'react';
import { useApplication, useDisplaySuccessScore } from "../../data";
import { SuccessScores } from "./SuccessScores";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
function ApplicationStepper(_ref) {
  var ariaLabelledBy = _ref['aria-labelledby'],
    ariaLabel = _ref['aria-label'];
  var _useApplicationWorkfl = useApplicationWorkflows(),
    workflows = _useApplicationWorkfl.workflows;
  var mainWorkflow = workflows.find(function (workflow) {
    return workflow.category === 'main';
  });
  assert(mainWorkflow, 'Could not find main workflow');
  var activeStep = mainWorkflow.status === 'completed' ? mainWorkflow.steps.length : mainWorkflow.steps.findIndex(function (step) {
    return step.status === 'in_progress' || step.status === 'paused';
  });
  var _useTranslation = useTranslation('ApplicationStepper'),
    t = _useTranslation.t;
  return _jsx(Stepper, {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    activeStep: activeStep,
    activeStepVariant: mainWorkflow.status === 'paused' ? 'terminal' : 'low_saliency',
    orientation: "vertical",
    children: mainWorkflow.steps.filter(function (step) {
      if (mainWorkflow.status === 'paused') {
        return step.status !== 'planned';
      }
      return true;
    }).map(function (step) {
      var _step$subSteps, _step$recommendedActi, _step$subSteps2;
      return _jsxs(Stepper.Step, {
        activeSubStep: (_step$subSteps = step.subSteps) === null || _step$subSteps === void 0 ? void 0 : _step$subSteps.findIndex(function (subStep) {
          return subStep.status === 'in_progress' || subStep.status === 'planned';
        }),
        children: [_jsx(Stepper.Step.Label, {
          variant: "bodyM",
          children: step.displayName
        }), _jsxs(Flex, {
          direction: "column",
          pt: 2,
          gap: 2,
          children: [step.internalDisplayName && _jsxs(Text, {
            contrast: "mid",
            variant: "bodyS",
            children: ["(", step.internalDisplayName, ")"]
          }), step.estimatedProcessingTime && _jsx(Flex.Item, {
            children: _jsx(Tag, {
              intent: "secondary",
              children: t('estimate', {
                estimate: formatDurationRange(step.estimatedProcessingTime)
              })
            })
          }), step.applicantActionDeadline && step.completionDeadline && _jsx(Flex.Item, {
            children: _jsx(Tooltip, {
              label: t(step.applicantActionDeadline === step.completionDeadline ? 'deadlineTooltipSameDeadlines' : 'deadlineTooltip', {
                applicantActionDeadline: formatDetailedDeadline(step.applicantActionDeadline),
                completionDeadline: formatDetailedDeadline(step.completionDeadline)
              }),
              children: _jsx(Tag, {
                as: "button",
                icon: "fill",
                intent: "warning",
                trailIcon: InfoOutlineIcon,
                children: t('deadline', {
                  deadline: format(new Date(step.completionDeadline), 'MMMM d, yyyy')
                })
              })
            })
          }), _jsx(Text, {
            variant: "bodyS",
            contrast: "mid",
            children: _jsx(Markdown, {
              textSettings: {
                variant: 'bodyS',
                contrast: 'mid'
              },
              headingSettings: {
                maxLevel: 0,
                baseLevel: 1
              },
              noticeSettings: {
                saliency: 'high'
              },
              markdown: step.internalDescription || step.description || ''
            })
          }), (_step$recommendedActi = step.recommendedActions) === null || _step$recommendedActi === void 0 ? void 0 : _step$recommendedActi.map(function (action) {
            return match(action)["with"]('manage_backup_programs', function () {
              return _jsx(ManageBackupProgramsButton, {
                size: "sm",
                emphasis: "highlighted"
              }, action);
            })["with"]('get_recommended_programs', function () {
              return _jsx(RecommendedProgramsButton, {
                size: "sm",
                emphasis: "highlighted"
              }, action);
            }).exhaustive();
          })]
        }), step.status === 'in_progress' && ((_step$subSteps2 = step.subSteps) === null || _step$subSteps2 === void 0 ? void 0 : _step$subSteps2.map(function (subStep) {
          return _jsx(Stepper.Step.SubStep, {
            children: subStep.internalDisplayName || subStep.displayName
          }, subStep.id);
        }))]
      }, step.id);
    })
  });
}
function SecondaryWorkflowList() {
  var _useApplicationWorkfl2 = useApplicationWorkflows(),
    workflows = _useApplicationWorkfl2.workflows;
  return _jsx(_Fragment, {
    children: workflows.filter(function (workflow) {
      return workflow.category === 'secondary' && workflow.steps.some(function (step) {
        return step.status === 'in_progress';
      });
    }).map(function (workflow) {
      return _jsx(SecondaryWorkflow, {
        workflow: workflow
      }, workflow.id);
    })
  });
}
function SecondaryWorkflow(_ref2) {
  var workflow = _ref2.workflow;
  var _useTranslation2 = useTranslation('ApplicationStepper'),
    t = _useTranslation2.t;
  var inProgressStep = workflow.steps.find(function (step) {
    return step.status === 'in_progress';
  });
  assert(inProgressStep, 'Could not find in progress step');
  return _jsxs(Notice, {
    intent: "primary",
    children: [inProgressStep.displayName, ".", ' ', inProgressStep.estimatedProcessingTime && t('estimateLongerSentence', {
      estimate: formatDurationRange(inProgressStep.estimatedProcessingTime)
    })]
  }, workflow.id);
}
export function ApplicationStepperCard(_ref3) {
  var ml = _ref3.ml,
    maxHeight = _ref3.maxHeight,
    threeSixtySolutionsAd = _ref3.threeSixtySolutionsAd;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useTranslation3 = useTranslation('ApplicationStepper'),
    t = _useTranslation3.t;
  var _useEventTracker = useEventTracker({
      group: 'Single Application V2'
    }),
    trackEvent = _useEventTracker.trackEvent;
  var containerRef = useRef(null);
  var _useApplication = useApplication(),
    application = _useApplication.application;
  return _jsx(Box, {
    width: isOpen ? {
      xs: 400,
      lg: 384,
      xl: 400
    } : 120,
    ml: ml,
    children: _jsx(Card, {
      p: 0,
      children: _jsx("div", {
        style: {
          maxHeight: maxHeight,
          overflowY: maxHeight ? 'auto' : undefined
        },
        ref: containerRef,
        children: _jsx(ErrorBoundary, {
          fallbackRender: function fallbackRender(_ref4) {
            var error = _ref4.error;
            return _jsx(Box, {
              p: 6,
              children: _jsx(IllustratedErrorState, {
                error: error,
                variant: "compact"
              })
            });
          },
          onError: function onError(error) {
            return trackEvent({
              event: 'Single Application V2 - ATS - Displayed Error',
              error: error
            });
          },
          children: isOpen ? _jsxs(_Fragment, {
            children: [_jsx(StickyBar, {
              sticky: !!application.newView,
              px: 6,
              pt: 6,
              pb: 4,
              borderTopRadius: "container",
              containerRef: containerRef,
              children: _jsx(Flex, {
                justify: isOpen ? 'start' : 'center',
                children: _jsx(Tooltip, {
                  label: t('collapse'),
                  children: _jsx(Button, {
                    emphasis: "highlighted",
                    intent: "primary",
                    "aria-label": t('collapse'),
                    leadIcon: isOpen ? MenuLeftExpandOutlineIcon : MenuLeftCollapseOutlineIcon,
                    onClick: function onClick() {
                      return setIsOpen(!isOpen);
                    }
                  })
                })
              })
            }), _jsx(ApplicationStepperCardContent, {
              threeSixtySolutionsAd: threeSixtySolutionsAd
            })]
          }) : _jsxs(_Fragment, {
            children: [_jsx(Flex, {
              px: 6,
              pt: 6,
              justify: isOpen ? 'start' : 'center',
              children: _jsx(Tooltip, {
                label: t('expand'),
                children: _jsx(Button, {
                  emphasis: "highlighted",
                  intent: "primary",
                  "aria-label": t('expand'),
                  leadIcon: isOpen ? MenuLeftExpandOutlineIcon : MenuLeftCollapseOutlineIcon,
                  onClick: function onClick() {
                    return setIsOpen(!isOpen);
                  }
                })
              })
            }), _jsx(CollapsedApplicationStepperCardContent, {
              threeSixtySolutionsAd: threeSixtySolutionsAd
            })]
          })
        })
      })
    })
  });
}
function ApplicationStepperCardContent(_ref5) {
  var threeSixtySolutionsAd = _ref5.threeSixtySolutionsAd;
  var _useDisplaySuccessSco = useDisplaySuccessScore(),
    displaySuccessScore = _useDisplaySuccessSco.displaySuccessScore;
  var applicationJourneyHeadingId = useId();
  var _useTranslation4 = useTranslation('ApplicationStepper'),
    t = _useTranslation4.t;
  return _jsxs(Flex, {
    direction: "column",
    px: 6,
    gap: 2,
    children: [displaySuccessScore && _jsx(SuccessScores, {}), threeSixtySolutionsAd, _jsxs(Flex, {
      direction: "column",
      gap: 2,
      children: [_jsxs(Flex, {
        align: "center",
        gap: 4,
        py: 4,
        children: [_jsx(LocationOutlineIcon, {}), _jsx(Heading, {
          id: applicationJourneyHeadingId,
          variant: "titleS",
          level: 2,
          children: t('applicationJourney')
        })]
      }), _jsx(SecondaryWorkflowList, {}), _jsx(ApplicationStepper, {
        "aria-labelledby": applicationJourneyHeadingId
      })]
    })]
  });
}
function CollapsedApplicationStepperCardContent(_ref6) {
  var threeSixtySolutionsAd = _ref6.threeSixtySolutionsAd;
  var _useTranslation5 = useTranslation('ApplicationStepper'),
    t = _useTranslation5.t;
  var _useDisplaySuccessSco2 = useDisplaySuccessScore(),
    displaySuccessScore = _useDisplaySuccessSco2.displaySuccessScore;
  var _useApplicationMainIn = useApplicationMainIntake(),
    isMainIntakeBelowCtaThreshold = _useApplicationMainIn.isMainIntakeBelowCtaThreshold;
  return _jsxs(Flex, {
    direction: "column",
    px: 4,
    pb: 2,
    children: [displaySuccessScore && _jsxs(_Fragment, {
      children: [_jsxs(Flex, {
        align: "center",
        direction: "column",
        py: 2,
        children: [_jsx(DashboardOutlineIcon, {}), _jsx(Text, {
          variant: "bodyS",
          align: "center",
          children: t('successScores')
        }), isMainIntakeBelowCtaThreshold && _jsx(WarningOutlineIcon, {
          intent: "warning"
        })]
      }), _jsx(Divider, {
        m: 0
      })]
    }), threeSixtySolutionsAd && _jsxs(_Fragment, {
      children: [_jsxs(Flex, {
        align: "center",
        direction: "column",
        py: 2,
        children: [_jsx(AwardOutlineIcon, {}), _jsx(Text, {
          variant: "bodyS",
          align: "center",
          children: t('360Solutions')
        })]
      }), _jsx(Divider, {
        m: 0
      })]
    }), _jsxs(Flex, {
      align: "center",
      direction: "column",
      py: 2,
      children: [_jsx(LocationOutlineIcon, {}), _jsx(Text, {
        variant: "bodyS",
        align: "center",
        children: t('applicationJourney')
      })]
    })]
  });
}
export function ApplicationStepperDrawerButton(_ref7) {
  var threeSixtySolutionsAd = _ref7.threeSixtySolutionsAd,
    width = _ref7.width;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var headingId = useId();
  var _useTranslation6 = useTranslation('ApplicationStepper'),
    t = _useTranslation6.t;
  var _useEventTracker2 = useEventTracker({
      group: 'Single Application V2'
    }),
    trackEvent = _useEventTracker2.trackEvent;
  return _jsxs(Drawer, {
    "aria-label": t('applicationJourney'),
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: "right",
    width: "sm",
    headingId: headingId,
    children: [_jsx(Drawer.Trigger, {
      children: _jsx(Button, {
        size: "sm",
        intent: "primary",
        emphasis: "highlighted",
        leadIcon: LocationOutlineIcon,
        width: width,
        children: t('applicationJourney')
      })
    }), _jsx(Flex, {
      justify: "end",
      children: _jsx(Button, {
        "aria-label": "Close",
        emphasis: "transparent",
        intent: "secondary",
        leadIcon: CloseOutlineIcon,
        onClick: function onClick() {
          return setIsOpen(false);
        },
        size: "sm"
      })
    }), _jsx(Flex, {
      direction: "column",
      gap: 4,
      children: _jsx(ErrorBoundary, {
        fallbackRender: function fallbackRender(_ref8) {
          var error = _ref8.error;
          return _jsx(Box, {
            p: 6,
            children: _jsx(IllustratedErrorState, {
              error: error,
              variant: "compact"
            })
          });
        },
        onError: function onError(error) {
          return trackEvent({
            event: 'Single Application V2 - ATS - Displayed Error',
            error: error
          });
        },
        children: _jsx(ApplicationStepperCardContent, {
          threeSixtySolutionsAd: threeSixtySolutionsAd
        })
      })
    })]
  });
}
export function ThreeSixtySolutionsAd(_ref9) {
  var _ref9$href = _ref9.href,
    href = _ref9$href === void 0 ? '/360-solutions' : _ref9$href;
  var _useTranslation7 = useTranslation('ApplicationStepper'),
    t = _useTranslation7.t;
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [_jsxs(Flex, {
      gap: 4,
      align: "center",
      children: [_jsx(AwardOutlineIcon, {}), _jsx(Heading, {
        level: 2,
        variant: "titleS",
        children: t('360Solutions')
      })]
    }), _jsxs(Flex, {
      direction: "column",
      gap: 2,
      children: [_jsx(Text, {
        children: t('360SolutionsInfo')
      }), _jsx(Link, {
        mode: "override_user_choice_and_open_in_new_tab",
        variant: "standalone",
        href: href,
        children: _jsx(Text, {
          children: t('360SolutionsLinkText')
        })
      })]
    })]
  });
}